<template>
  <div id="app">
    <modals-container class="ios-safari-modal-container"/>
    <router-view name="partners" key="partners" />
    <router-view name="voucher" key="voucher" />
  </div>
</template>
<script>
import { EventBus } from '@/components/eventbus/EventBus'
import AlertModal from '@/components/modal/AlertModal'
import ConfirmModal from '@/components/modal/ConfirmModal'

export default {
  name: 'PartnersApp',
  mounted () {
    EventBus.$on('open-alert', ({ text, callbackFn }) => {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) - 30
      const width = w > 300 ? 300 : w
      this.$modal.show(AlertModal,
        { text, callbackFn },
        { width, maxWidth: 300, height: 'auto', minHeight: 290, clickToClose: false }
      )
    })
    EventBus.$on('open-confirm', ({ text, resolveFn }) => {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) - 30
      const width = w > 300 ? 300 : w
      this.$modal.show(ConfirmModal,
        { text, resolveFn },
        { width, maxWidth: 300, height: 'auto', minHeight: 290, clickToClose: false }
      )
    })
  }
}
</script>
<style lang="css" src="@/assets/new-css/shareholder.css"></style>
<style lang="css" src="@/assets/new-css/login.css"></style>
<style>
  #app {
    height: auto;
    min-height: 100vh;
  }
</style>
